// extracted by mini-css-extract-plugin
export default {"tooltip":"ToolTip_tooltip__0RLAZ","tooltip__arrow":"ToolTip_tooltip__arrow__2RFJ8","top":"ToolTip_top__0rfQr","bottom":"ToolTip_bottom__+CSYI"};